import React, { useState, useEffect, Fragment } from 'react';
import { NavLink, useParams, useHistory } from "react-router-dom";
import { ChangeHistoryDetailModel } from './models/change.history.detail.model';
import { ChangeHistoryService } from './services/change.history.service';
import { HttpResponse } from '../../../../src/core';
import { ConvertDateTime, HandleNotFoundResponse } from '../../../../src/shared/helpers';
import { Editor } from '../../../../src/shared';
import { AccountChangeHistoryTabs } from './AccountChangeHistoryTabs';
import { NotFoundResponseArea } from '../../../../src/shared/enums';
import { Loader } from '../../../../src/shared/loaders';
import { AccountChangeHistoryDescription } from './AccountChangeHistoryDescription';

interface RouteParams {
    id: string;
}

export const AccountChangeHistoryDetail: React.FC = () => {
    const { id } = useParams<RouteParams>();
    const history = useHistory();

    const [result, setResult] = useState<ChangeHistoryDetailModel | null>(null);
    const [parsedData, setParsedData] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const service = new ChangeHistoryService();


    const loadData = async () => {
        setIsLoading(true);
        try {
            const res: HttpResponse<ChangeHistoryDetailModel> = await service.getChangeHistoryById(Number(id));
            if (res?.result) {
                const data = res.result;

                const object = {
                    ...(data.object),
                };

                setResult(data);
                setParsedData(JSON.stringify(object, null, '\t'));
            }
        } catch (ex) {
            HandleNotFoundResponse(ex, NotFoundResponseArea.AccountChangeHistories, history);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    // check result before rendering
    return (
        <Fragment>
            <div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4>
                        Details for Account Change History '{result ? ConvertDateTime(result.created_at, 'LLL') : "..."}'
                    </h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <AccountChangeHistoryTabs id={Number(id)} url="/account-change-history/detail/" />
                                {!isLoading && result && (
                                    <>
                                        <h5 className="mb-3">Basic Info</h5>
                                        <div className="row">
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold"> Account </div>
                                                    <div className="card-body">
                                                        <NavLink to={`/account/detail/${result.item_id}`}>
                                                            {result.item_id}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold"> Edited By </div>
                                                    <div className="card-body">
                                                        <NavLink to={`/user/detail/${result.user_id}`}>
                                                            {result.user_name}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold"> Edited At </div>
                                                    <div className="card-body">
                                                        {ConvertDateTime(result.created_at, 'LLL')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="card card-silver shadow-sm">
                                                    <div className="card-header font-weight-bold"> Ip </div>
                                                    <div className="card-body">{result.ip}</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mt-3">
                                            <div className="col-md-6">
                                                <h6>Description</h6>
                                                <AccountChangeHistoryDescription result={result} />
                                            </div>
                                            {result.object && (
                                                <div className="col-md-6">
                                                    <h6>Account Definition Before Changes</h6>
                                                    <Editor StringData={parsedData} FormateType="json" />
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                                {isLoading && <Loader loading={isLoading} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};